import {NewAboutI18n} from '@/locales/base.message.locales';

export const newAboutI18n: NewAboutI18n = {
  section_13: {
    p4: 'É um nome do tipo simbólico, se conectado com as causas representadas e <br/>  os agentes que se envolvem como exemplo para outros.',
    p1: 'A palavra <strong>Ikone é derivado do grego, (eikon, imagem).</strong>',
    p2: 'No campo da <strong>arte religiosa</strong> identifia uma <strong>representação sagrada.</strong>',
    p3: ' No campo da <strong>psicologia</strong>, icone é uma imagem que <strong>representa algo.</strong>',
    title: '<strong>Um movimento <br> que destrava, tira <br> do eixo e faz</strong>'
  },
  section_12: {
    p: 'Em ações de impacto social através de um movimento global descentralizado através de inovação aberta com plataforma de desafios online e ações de impacto no mundo real.',
    title: 'Queremos alcançar o equivalente a 1 bilhão de pessoas no mundo'
  },
  section_11: {
    p1: `<strong>Abordamos os Grandes Desafios do Mundo</strong>,
              criando e gerenciando uma plataforma múltipla - físicas e virtuais -
              para conectar empreendedores, empresas e governo a resolver
              desafios sociais com complexos de comunidades pobres e emergentes, multiplicando soluções de
              exportação de impacto para outras partes do mundo.`,
    p2: `<strong>Como casamenteiros, integramos a liga social - um laboratório vivo - um ambiente do mundo
                real.</strong>`,
    p3: `Por onde começamos? Como começamos a responder a
              esse grande desafio? Pensamos que devemos começar do
              zero em terras virgens para construir esse tipo especial de
              nova comunidade.`,
    p4: `Este Living Lab é um convite aos
                      ideais, sonhos e soluções para os
                      desafios do complexo social
                      presentes nas comunidades de 3.5
                      bilhões de pessoas - a metade mais
                      pobre da população do mundo.`,
    p5: `De startups a grandes corporações, todas precisam
                    testar e demonstrar aplicativos como impressão 3D para
                    habitação, Inteligência Artificial digital para prevenção da
                    saúde, blockchain para transformar a governança pública.
                    VR e AR para elevar a educação, análise computadorizada para
                    melhor segurança e todas as inovações para alavancar
                    este laboratório vivo.
`,
    p6: `Mais importante ainda, quando encontramos a necessidade de
                  soluções e tecnologias sociais que ainda não existem, é nossa
                  esperança que estimulemos os cidadãos de todo o mundo a
                  desenvolver novas soluções em suas próprias comunidades.
                  Soluções que atenderão às necessidades das pessoas expressas
                  nesta comunidade experimental.`,
    title: 'LIVING LAB'
  },
  section_10: {
    p1: `Acreditamos que é preciso se doar. Vamos
                    facilitar o despertar de talentos e conecta-los
                    com as iniciativas sociais de impacto global,
                    a fim de realizar o bem de forma contagiante -
                    multiplicando resultados.`,
    p2: '<strong>Não basta doar é preciso se doar.</strong>',
    p3: `Nossas iniciativas sociais cativão e dão esperança
                    para milhares de pessoas que entendem a necessidade de lutar contra
                    problemas de saúde; se beneficiar da
                    educação e interromper o ciclo da pobreza
                    criando uma mudança positiva e duradoura`
  },

  section_9: {
    p1: 'Fundo de investimentos de impacto social',
    p2: 'Monitoramento e Avaliações',
    p3: 'Resultados (TIR SOCIAL)',
    p4: 'Parcerias globais',
    title: 'Foco em resultados duradouros'
  },
  section_8: {
    p1: `NOSSO <strong> EFEITO <br/> MULTIPLICADOR</strong>`,
    p2: `<strong>Firmamos parcerias com as mais efetivas e abrangentes
                      organizações globais que viabilizam recursos humanos
                      e financeiros.</strong>`,
    p3: `Fazemos a conexão com os melhores profissionais locais (on the
                    ground) para focar nossos recursos em problemas críticos, entregando
                    resultados numa escala que poucos podem atingir sozinhos;
                    buscamos uma TIR SOCIAL, uma taxa de retorno sob investimento que
                    chega a ampliar em até 20x os investimentos realizados.`
  },

  section_7: {
    p1w1: '<strong>Ligamos</strong>',
    p1w2: '<span>Projetos de <br> alto impacto</span>',
    p2w1: '<strong>Integramos</strong>',
    p2w2: '<span>Oportunidades <br> de transformar</span>',
    p3w1: '<strong>Conectamos</strong>',
    p3w2: '<span>Talentos Locais</span>'
  },

  section_6: {
    p1: `Somos uma liga social que ganha
                sentido quando fomenta comunidades
                mais prósperas e autônomas.`,
    p2: ` <strong>
                  Somos Ikone, sinônimo da vocação para facilitar
                  uma mudança urgente, positiva e duradoura que
                  transforma as vidas da nossa terra.
                </strong>`
  },

  section_5: {
    p1: `Promovemos inovação,
                  mapeando projetos e causas
                  que precisam acontecer.`,
    p2: ` Temos o compromisso de mobilizar uma rede de
                    talentos locais e parcerias globais para realizar, em
                    larga escala e com alto impacto, o que muitos
                    consideram impossível.`
  },
  section_4: {
    p1: `Crescemos com a inquietação e a consciência de
                que os desafios são enormes, envolvem
                tentativas onde muito se perde e a sensação de
                impotência desencoraja a ação.`,
    p2: `Somos resilientes e conectores.
                Multiplicamos resultados e fazemos o futuro onde todos ganham.`
  },

  section_3: {
    p1: `<strong>Nascemos</strong><br>
                para mostrar <br>
                que <strong>dá certo.</strong>`
  },

  section_2: {
    p1: ` O <strong>movimento</strong> <br>
                  que precisa <br>
                  <strong>acontecer.</strong>`,
    p2: `Somos uma organização
                          cujo objetivo é reunir uma liga social global de
                          atores inovadores, empreendedores e investidores
                          para combater a pobreza e criar prosperidade.`,
    p3: `        Para lidar com um cenário tão crítico e quebrar
                          o ciclo da pobreza, colocamos em prática
                          nossos conhecimentos e adotamos programas
                          sociais efetivos dentro dos objetivos de
                          desenvolvimento sustentável da ONU.`
  },

  section_1: {title: 'SOMOS UMA LIGA SOCIAL GLOBAL'},

}
